/**
 * 共通処理
 */
import * as constants from "@/mixin/constants";

var platform = require("platform");
var crypto = require("crypto");

export default {
  data() {
    return {
      // 現在のスクロール量
      scrollY: 0
    };
  },
  methods: {
    /**
     * ログ出力
     */
    log: function(message) {
      // 開発環境のときだけ、ログ出力
      var env = process.env.DEPLOY_ENV;
      if (env !== "production") {
        console.log(message);
      }
    },
    /**
     * スコア情報を分割する
     * 配列0番: levelNo
     * 配列1番: unitNo
     * 配列2番: lesson index
     * 配列3番: path index
     * 配列4番: pathStep index
     * 配列5番: "ok" or "ng" or "skip"
     */
    splitScore: function(score) {
      var res = [];

      var key = Object.keys(score);
      var split = key[0].split("-");
      if (split.length != 8) {
        return res;
      }

      res.push(Number(split[2]), Number(split[3]), Number(split[4]), Number(split[5]), Number(split[6]), split[7]);
      return res;
    },
    /**
     * 進捗情報を分割する
     * 配列0番: levelNo
     * 配列1番: unitNo
     * 配列2番: lesson index
     * 配列3番: path index
     */
    splitProgress: function(progress) {
      var res = [];

      var key = Object.keys(progress);
      var split = key[0].split("-");
      if (split.length != 6) {
        return res;
      }

      res.push(Number(split[2]), Number(split[3]), Number(split[4]), Number(split[5]));
      return res;
    },
    /**
     * pathStep数の情報を分割する
     * 配列0番: levelNo
     * 配列1番: unitNo
     * 配列2番: lesson index
     * 配列3番: path index
     */
    splitPathStepLen: function(pathStepLen) {
      var res = [];

      var key = Object.keys(pathStepLen);
      var split = key[0].split("-");
      if (split.length != 7) {
        return res;
      }

      res.push(Number(split[3]), Number(split[4]), Number(split[5]), Number(split[6]));
      return res;
    },
    /**
     * JSONのlevelNoとnumberが一致するデータを取得
     */
    getLevelJson: function(jsonData, number) {
      var res = null;

      for (var level of jsonData.levels) {
        if (level.levelNo == number) {
          res = level;
          break;
        }
      }
      return res;
    },
    /**
     * JSONのlevelNoとnumberが一致するデータのindexを取得
     */
    getLevelIndex: function(jsonData, number) {
      var res = -1;

      for (var [index, level] of jsonData.levels.entries()) {
        if (level.levelNo == number) {
          res = index;
          break;
        }
      }
      return res;
    },
    /**
     * JSONのunitNoとnumberが一致するデータを取得
     */
    getUnitJson: function(levelJson, number) {
      var res = null;

      for (var unit of levelJson.units) {
        if (unit.unitNo == number) {
          res = unit;
          break;
        }
      }
      return res;
    },
    /**
     * JSONのunitNoとnumberが一致するデータのindexを取得
     */
    getUnitIndex: function(levelJson, number) {
      var res = -1;

      for (var [index, unit] of levelJson.units.entries()) {
        if (unit.unitNo == number) {
          res = index;
          break;
        }
      }
      return res;
    },
    /**
     * マイク一覧取得
     *
     * @return {Promise} resolve:有効なマイクオブジェクト一覧
     */
    getMicrophones: function() {
      var result = [];
      return new Promise(function(resolve) {
        switch (platform.name) {
          case "Chrome":
            navigator.mediaDevices.enumerateDevices().then(function(devices) {
              for (var device of devices) {
                if (device.kind == "audioinput" && device.deviceId != "default" && device.deviceId != "communications") {
                  result.push({ name: device.label, id: device.deviceId });
                }
              }
              resolve(result);
            }).catch(function(err) {
              this.log(err.name + ": " + err.message);
              resolve(result);
            });
            break;
          default:
            resolve(result);
            break;
        }
      });
    },
    /**
     * マイク設定要否を返す
     *
     * @param {Object} current マイクオブジェクト
     * @return {Boolean} true:要設定, false:設定不要
     */
    needsMicrophoneSetting: async function(current) {
      switch (platform.name) {
        case "Chrome":
          var microphones = await this.getMicrophones();
          return microphones.every(function(microphone) { return !current || microphone.id != current.id; });
        // Chrome以外のブラウザでは判定できない
        default:
          return false;
      }
    },
    /**
     * SREの設定情報をログ出力
     */
    outputLogSonicSettings: function() {
      this.log(platform.description);
      if (window.hasOwnProperty("Phone")) {
        return;
      }
      this.log("SRE version : " + speechEngine.getVersion());
      var model = speechEngine.getConfiguredModelDescriptor();
      var language = model.getLanguage();
      var voiceType = model.getVoiceType();
      var difficulty = speechEngine.getConfiguredDifficulty();
      this.log("SRE configured for " + language + ", " + voiceType + " (difficulty " + difficulty + ")");
    },
    /**
     * Safariの問題画面ブラウザ縮小時の高さ調整
     */
    fixtHeightForSafari: function(contentHeight) {
      var windowHeight = window.innerHeight;
      $("body").css("height", "100vh");
      $(".page-content").css("height", windowHeight - contentHeight + "px");

      $(window).resize(function() {
        var windowHeight = window.innerHeight;
        $("body").css("height", "100vh");
        $(".page-content").css("height", windowHeight - contentHeight + "px");
      });
    },
    /**
     * Safariのログイン、シリアル、ローディング画面のブラウザ縮小時の高さ調整
     */
    fixtHeightForSafariFullWindow: function() {
      var windowHeight = window.innerHeight;
      $("body").css("height", windowHeight + "px");
      $(".inner.flexcenter").css("height", windowHeight + "px");

      $(window).resize(function() {
        var windowHeight = window.innerHeight;
        $("body").css("height", windowHeight + "px");
        $(".inner.flexcenter").css("height", windowHeight + "px");
      });
    },
    /**
     * 実行環境がPCの場合trueを返却する
     */
    isEnvironmentPc: function() {
      var p = window.hasOwnProperty("Phone");
      if (p) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 実行環境がモバイルアプリの場合、bodyにclass'modal-open'を追加する
     * モーダル画面表示中はスクロール不可にするため
     *
     * @param {Boolean} add trueの場合は追加、falseの場合は削除
     */
    setBodyStylePosition: function(add) {
      var p = window.hasOwnProperty("Phone");
      if (!p) {
        // PCの場合、何もしない
        return;
      }

      if (add) {
        scrollY = window.pageYOffset;
        document.getElementsByTagName("body")[0].classList.add("modal-open");
        document.body.style.top = -1 * scrollY + "px";
      } else {
        document.getElementsByTagName("body")[0].classList.remove("modal-open");
        document.body.style.top = "";
        window.scrollTo(0, scrollY);
      }
    },
    /**
     * Flash版実行強制フラグを取得する
     *
     * @return {Boolean} true：Flash版で動作させる、false：左記以外
     */
    isForceFlash: function() {
      if (this.isEnvironmentPc()) {
        switch (platform.name) {
          case "IE":
            // IEはFlash版で動作させる
            return true;
          case "Safari":
            // Safariはブラウザバージョンによって判定
            return this.isOldSafari();
          default:
            // 上記以外はSREが判断する
            return false;
        }
      } else {
        // モバイルアプリ版
        return false;
      }
    },
    /**
     * 音声アイコンを有効にする
     */
    enabledIconVoice: function() {
      var iconVoice = $(".icon-voice");

      // 音声再生ボタンを有効にする
      iconVoice.removeClass("disabled");
      $(iconVoice).prop("disabled", false);
    },
    /**
     * 音声アイコンを無効にする
     */
    disabledIconVoice: function() {
      var iconVoice = $(".icon-voice");

      // 音声再生ボタンを無効にする
      iconVoice.addClass("disabled");
      $(iconVoice).prop("disabled", true);
    },
    /**
     * 音声アイコンの有効/無効を返す
     */
    isIconVoiceEnabled: function() {
      var iconVoice = $(".icon-voice");
      return !$(iconVoice).prop("disabled");
    },
    /**
     * 指定されたscriptidのbasicTextを取得する
     */
    getBasicTextByScriptid: function(actJson, scriptid) {
      for (var i = 0; i < actJson.texts.length; i++) {
        var id = actJson.texts[i].scriptID;
        if (id === scriptid) {
          return actJson.texts[i].basicText;
        }
      }

      return "";
    },
    /**
     * 指定されたscriptidのtileTextを取得する
     */
    getTileTextByScriptid: function(actJson, scriptid) {
      for (var i = 0; i < actJson.texts.length; i++) {
        var id = actJson.texts[i].scriptID;
        if (id === scriptid) {
          return actJson.texts[i].tileText;
        }
      }

      return "";
    },
    /**
     * 指定されたscriptidのText情報を取得する
     */
    getTextInfoByScriptid: function(texts, scriptid) {
      for (var i = 0; i < texts.length; i++) {
        var id = texts[i].scriptID;
        if (id === scriptid) {
          return texts[i];
        }
      }

      return null;
    },
    /**
     * モバイルアプリで実行中か否かを返す
     *
     * @return {Boolean} true：モバイルアプリで実行中, false：左記以外
     */
    isMobile: function() {
      return window.hasOwnProperty("Phone");
    },
    /**
     * Androidアプリで実行中か否かを返す
     *
     * @return {Boolean} true：Androidアプリで実行中, false：左記以外
     */
    isAndroid: function() {
      return this.isMobile() && window.Phone.GetPlatformName() == constants.PLATFORM_ANDROID;
    },
    /**
     * ドコモ版Androidアプリで実行中か否かを返す
     *
     * @return {Boolean} true：ドコモ版Androidアプリで実行中, false：左記以外
     */
    isDocomo: function() {
      var result = false;
      if (this.isAndroid()) {
        result = window.Phone.GetPackageName().startsWith(constants.PACKAGE_DOCOMO_ANDROID);
      }
      return result;
    },
    /**
     * au版Androidアプリで実行中か否かを返す
     *
     * @return {Boolean} true：au版Androidアプリで実行中, false：左記以外
     */
    isAu: function() {
      var result = false;
      if (this.isAndroid()) {
        result = window.Phone.GetPackageName().startsWith(constants.PACKAGE_AU_ANDROID);
      }
      return result;
    },
    /**
     * softbank版Androidアプリで実行中か否かを返す
     *
     * @return {Boolean} true：softbank版Androidアプリで実行中, false：左記以外
     */
    isSoftbank: function() {
      var result = false;
      if (this.isAndroid()) {
        result = window.Phone.GetPackageName().startsWith(constants.PACKAGE_SOFTBANK_ANDROID);
      }
      return result;
    },
    /**
     * キャリア版Androidアプリで実行中か否かを返す
     *
     * @return {Boolean} true：キャリア版Androidアプリで実行中, false：左記以外
     */
    isCarrier: function() {
      return this.isDocomo() || this.isAu() || this.isSoftbank();
    },
    /**
     * 指定された平文のSHA256ハッシュ値をHEX文字列で取得する
     *
     * @param {String} plainText 平文
     *
     * @return {String} 指定された平文のSHA256ハッシュ値のHEX文字列
     */
    getSha256HashHexString: function(plainText) {
      var hash = crypto.createHash("sha256");
      hash.update(plainText);
      return hash.digest("hex");
    },
    /**
     * 言語、スクリプトIDごとのbasicTextを取得する
     *
     * @param {Array} texts 問題データのtexts
     * @param {String} language 言語コード
     * @param {String} scriptType テキストの表示形式
     * @param {String} displayMode 複数表示形式がある場合の表示形式
     * @param {String} defaultScript デフォルトスクリプトID
     *
     * @returns {String}
     */
    getLanguageBasicText: function(texts, language, scriptType, displayMode, defaultScript) {
      var str = "";

      if (language === constants.LANGUAGE_CODE_ZHCV) {
        // 中国語
        str = this.getChineseText(texts, scriptType, displayMode);
      } else if (language === constants.LANGUAGE_CODE_HEIL) {
        // ヘブライ語
        var scriptId = this.getHebrewScriptID(displayMode);
        var info = this.getTextInfoByScriptid(texts, scriptId);
        str = info.basicText;
      } else if (language === constants.LANGUAGE_CODE_JAJP) {
        // 日本語
        str = this.getJapaneseText(texts, displayMode);
      } else if (language === constants.LANGUAGE_CODE_AR) {
        // アラビア語
        var info = this.getTextInfoByScriptid(texts, defaultScript);
        str = info.basicText;
      } else if (language === constants.LANGUAGE_CODE_FAIR) {
        // ペルシア語
        var info = this.getTextInfoByScriptid(texts, defaultScript);
        str = info.basicText;
      } else {
        str = texts[0].basicText;
      }

      return str;
    },
    /**
     * スクリプトIDから表示するテキスト要素を取得する
     *
     * @param {Array} texts
     * @param {String} language 言語コード
     * @param {String} scriptType 文字形式
     * @param {String} displayMode 表示形式
     * @param {String} defaultScript デフォルトスクリプトID
     *
     * @returns {Object} JSONテキストオブジェクト
     */
    getTextObjByScriptID: function(texts, language, scriptType, displayMode, defaultScript) {
      var ret = {
        textObj: null,
        pinyin: null,
        kana: false
      };

      if (language === constants.LANGUAGE_CODE_ZHCV) {
        // 中国語
        // スクリプトID取得
        var scriptID = this.getChineseScriptID(scriptType, displayMode);
        var pinyin = null; // ピンイン文字リスト
        // 対象スクリプトIDのconfuserリスト取得
        for (let i = 0; i < texts.length; i++) {
          if (texts[i].scriptID == scriptID) {
            ret.textObj = texts[i];
          }
          if (displayMode == constants.DISPLAY_MODE_WITH_PINYIN) {
            // ピンイン付きの場合、ピンイン文字一覧取得
            ret.pinyin = texts[i];
          }
        }
      } else if (language === constants.LANGUAGE_CODE_HEIL) {
        // ヘブライ語
        var scriptId = this.getHebrewScriptID(displayMode);
        ret.textObj = this.getTextInfoByScriptid(texts, scriptId);
      } else if (language === constants.LANGUAGE_CODE_JAJP) {
        // 日本語
        var scriptId = this.getJapaneseScriptID(displayMode);
        ret.textObj = this.getTextInfoByScriptid(texts, scriptId);
        ret.kana = displayMode == constants.DISPLAY_MODE_KANJI_WITH_KANA;
      } else if (language === constants.LANGUAGE_CODE_AR) {
        // アラビア語
        ret.textObj = this.getTextInfoByScriptid(texts, defaultScript);
      } else if (language === constants.LANGUAGE_CODE_FAIR) {
        // ペルシア語
        ret.textObj = this.getTextInfoByScriptid(texts, defaultScript);
      } else {
        // その他言語(scriptidが1つだけ)
        ret.textObj = texts[0];
      }

      return ret;
    },
    /**
     * ACT内のテキスト一覧取得
     *
     * @param {Array} acts 問題データのact一覧
     * @param {String} language 言語コード
     * @param {String} scriptType 文字形式
     * @param {String} displayMode 表示形式
     * @param {String} defaultScript デフォルトスクリプトID
     *
     * @returns {Array}
     */
    getLanguageBasicTextList: function(acts, language, scriptType, displayMode, defaultScript) {
      var ret = [];
      for (var i = 0; i < acts.length; i++) {
        ret[i] = this.getLanguageBasicText(acts[i].texts, language, scriptType, displayMode, defaultScript);
      }
      return ret;
    },
    /**
     * ACT内の表示モード毎basicTextを全て取得する
     *
     * @param {Array} acts 問題データのact一覧
     * @param {String} language 言語コード
     * @param {String} scriptType 文字形式
     * @param {String} defaultScript デフォルトスクリプトID
     * @param {Boolean} isChallengeOnly true:Challengeのみ対象, false:左記以外
     *
     * @returns {Object} ACT内の表示モード毎の全basicText(ルビ付き含む)
     */
    getAllBasicTexts: function(acts, language, scriptType, defaultScript, isChallengeOnly) {
      let result = {};

      // 全basicTextを抽出
      let targets = [];
      for (let act of acts) {
        let isTarget = true;

        // Challengeのみが対象か判定
        if (isChallengeOnly) {
          isTarget = act.usage == 1;
        }

        if (isTarget) {
          targets.push(this.getAllDisplayModeTexts(act, language, scriptType, defaultScript));
        }
      }

      // 表示モード毎にグルーピング
      const push = Array.prototype.push;
      for (let target of targets) {
        for (let displayMode in target) {
          if (!result[displayMode]) {
            result[displayMode] = [];
          }
          push.apply(result[displayMode], target[displayMode]);
        }
      }

      return result;
    },
    /**
     * 指定されたACTの全表示モードのbasicTextを取得する
     *
     * @param {Object} act 問題データのact
     * @param {String} language 言語コード
     * @param {String} scriptType 文字形式
     * @param {String} defaultScript デフォルトスクリプトID
     *
     * @returns {Object} 指定されたACTの全表示モードのbasicText(ルビ付き含む)
     */
    getAllDisplayModeTexts: function(act, language, scriptType, defaultScript) {
      let result = {};

      const self = this;

      const addResult = function(displayMode, targetText) {
        if (!result[displayMode]) {
          result[displayMode] = [];
        }
        result[displayMode].push(targetText);
      };
      const addResultRuby = function(targetType) {
        let displayMode = self.getRubyDisplayMode(language);
        let basicText = self.getLanguageBasicText(act.texts, language, targetType, displayMode, defaultScript);
        addResult(displayMode, basicText);
      };

      // 全スクリプトIDのbasicTextを抽出
      for (let text of act.texts) {
        let scriptId = text.scriptID;
        let displayMode = this.getDisplayMode(language, scriptId, false);
        if (constants.DISPLAY_MODE_NONE == displayMode && scriptId != defaultScript) {
          // 表示モードが無い言語はデフォルトのスクリプトIDのみを対象とする
          continue;
        }
        addResult(displayMode, text.basicText);
      }
      // ルビ付きテキストを抽出
      switch (language) {
        case constants.LANGUAGE_CODE_ZHCV:
          for (let targetType of constants.SCRIPT_TYPE_LIST) {
            addResultRuby(targetType);
          }
          break;
        case constants.LANGUAGE_CODE_JAJP:
          addResultRuby(scriptType);
          break;
        default:
          // Ignore
          break;
      }

      return result;
    },
    /**
     * 中国語のスクリプトID取得
     *
     * @param {String} scriptType 文字形式
     * @param {String} displayMode 表示形式
     *
     * @returns {String} スクリプトID
     */
    getChineseScriptID: function(scriptType, displayMode) {
      var scriptID = scriptType;
      if (displayMode == constants.DISPLAY_MODE_PINYIN_ONLY) {
        scriptID = constants.TEXT_SCRIPTID_PINYIN;
      }
      return scriptID;
    },
    /**
     * ヘブライ語のスクリプトIDを取得する
     *
     * @param {String} displayMode 表示形式
     *
     * @returns {String} スクリプトID
     */
    getHebrewScriptID: function(displayMode) {
      switch (displayMode) {
        case constants.DISPLAY_MODE_UNVOWELED:
          return constants.TEXT_SCRIPTID_UNVOWELED;
        default:
          return constants.TEXT_SCRIPTID_VOWELED;
      }
    },
    /**
     * 日本語のスクリプトIDを取得する
     *
     * @param {String} displayMode 表示形式
     *
     * @returns {String} スクリプトID
     */
    getJapaneseScriptID: function(displayMode) {
      switch (displayMode) {
        case constants.DISPLAY_MODE_KANJI_WITH_KANA:
        case constants.DISPLAY_MODE_KANJI:
          return constants.TEXT_SCRIPTID_KANJI;
        case constants.DISPLAY_MODE_ROMAJI:
          return constants.TEXT_SCRIPTID_ROMAJI;
        default:
          return constants.TEXT_SCRIPTID_KANA;
      }
    },
    /**
     * 中国語テキスト取得
     *
     * @param {Array} texts テキスト情報
     * @param {String} scriptType 文字形式
     * @param {String} displayMode 表示形式
     *
     * @returns {String} 中国語テキスト
     */
    getChineseText: function(texts, scriptType, displayMode) {
      // 中国語
      var ret = "";
      var scriptID = this.getChineseScriptID(scriptType, displayMode);
      for (var i = 0; i < texts.length; i++) {
        if (texts[i].scriptID == scriptID) {
          ret = texts[i].basicText;
        }
      }
      // ピンインありの処理
      if (displayMode == constants.DISPLAY_MODE_WITH_PINYIN) {
        // HTMLタグ正規表現パターン
        var htmlTagReg = /(<\w+(?:\s+[^>]+)?\/?>|<\/\w+>)/g;
        // ピンイン文字列
        var pinyin = "";
        // ピンイン文字列取得
        for (var i = 0; i < texts.length; i++) {
          if (texts[i].scriptID == constants.TEXT_SCRIPTID_PINYIN) {
            pinyin = texts[i].basicText;
          }
        }

        if (pinyin) {
          var resultText = this.getChineseTextWithPinyin(ret, pinyin);
        }
        ret = resultText;
      }
      return ret;
    },
    /**
     * 日本語テキスト取得
     *
     * @param {Array} texts テキスト情報
     * @param {String} displayMode 表示形式
     *
     * @returns {String} 日本語テキスト
     */
    getJapaneseText: function(texts, displayMode) {
      var result;

      var scriptId = this.getJapaneseScriptID(displayMode);
      var text = texts.find(function(element) { return element.scriptID == scriptId; });

      if (displayMode == constants.DISPLAY_MODE_KANJI_WITH_KANA) {
        result = this.getJapaneseTextWithKana(text.basicText, text.superScripts);
      } else {
        result = text.basicText;
      }

      return result;
    },
    /**
     * 中国語のピンイン付き表記取得
     * @param string text 元の文字
     * @param string pinyinText  ピンイン文字
     * @returns string
     */
    getChineseTextWithPinyin: function(text, pinyinText) {
      var htmlTagReg = /(<\w+(?:\s+[^>]+)?\/?>|<\/\w+>)/g;
      // ピンインを文字ごとに分割
      var splits = pinyinText.replace(htmlTagReg, "").replace(/([!-/]|[:-?]|《|》|“|”)/g, " $& ").split(" ");
      var pinyinList = [];
      for (var i = 0; i < splits.length; i++) {
        if (splits[i].length != 0) {
          pinyinList.push(splits[i]);
        }
      }
      // 文字列をHTMLタグで分割
      var splitList = text.split(htmlTagReg);
      // 1文字ごとに分割
      var strList = [];
      for (var i = 0; i < splitList.length; i++) {
        if (splitList[i].match(htmlTagReg)) {
          // HTMLタグはそのまま追加
          strList.push(splitList[i]);
        } else {
          // 数値を判別
          var tmpList = splitList[i].split(/([+,-]?[[1-9]\d*|0])/g);
          for (var j = 0; j < tmpList.length; j++) {
            if (tmpList[j].replace(" ", "") == "") {
              continue;
            } else if (tmpList[j].match(/([+,-]?[[1-9]\d*|0])/g)) {
              strList.push(tmpList[j]);
            } else {
              Array.prototype.push.apply(strList, tmpList[j].replace(" ", "").split(""));
            }
          }
        }
      }
      // 1文字ごとにルビをつける。
      var pinyinIndex = 0;
      var resultText = "";
      for (var j = 0; j < strList.length; j++) {
        if (!strList[j].match(htmlTagReg)) {
          // 文字
          if ((strList[j] || strList[j] === 0) && pinyinList[pinyinIndex]) {
            resultText += "<ruby>" + strList[j] + "<rt>" + pinyinList[pinyinIndex] + "</rt>" + "</ruby>";
            pinyinIndex++;
          } else {
            resultText += "<ruby>" + strList[j] + "<rt>&nbsp;</rt></ruby>";
          }
        } else {
          // HTMLタグはそのまま
          resultText += strList[j];
        }
      }

      return resultText;
    },
    /**
     * 日本語のふりがな付き漢字テキストを取得する
     *
     * @param {String} text 対象テキスト
     * @param {Array} superScripts ふりがな情報
     * @param {Array} confusers 選択肢情報(未指定可)
     *
     * @return {String} ふりがな付き漢字テキスト
     */
    getJapaneseTextWithKana: function(text, superScripts, confusers) {
      var result = "";
      var htmlTagReg = /(<\w+(?:\s+[^>]+)?\/?>|<\/\w+>)/g;
      var spanEndTagReg = /<\/span>/g;
      var fontStartTagReg = /<font(?:\s+[^>]+)?\/?>/g;
      var fontEndTagReg = /<\/font>/g;

      // 文字列をHTMLタグで分割
      var htmlTagSplits = text.split(htmlTagReg);
      // 1文字ごとに分割
      var words = [];
      var push = Array.prototype.push;
      for (var htmlTagSplit of htmlTagSplits) {
        if (htmlTagReg.test(htmlTagSplit)) {
          // HTMLタグはそのまま追加
          words.push(htmlTagSplit);
        } else {
          push.apply(words, htmlTagSplit.split(""));
        }
      }

      // 漢字にルビをつける
      var position = 0;
      var confuserIndex = 0;
      for (var i = 0; i < words.length; i++) {
        if (spanEndTagReg.test(words[i])) {
          // HTMLタグはそのまま
          result += words[i];
          // 空所の文字数分位置を移動
          var correct = confusers[confuserIndex++].find(function(element) { return element.correct; });
          position += correct.text.length;
        } else if (htmlTagReg.test(words[i])) {
          // HTMLタグはそのまま
          result += words[i];
        } else {
          // ふりがな情報取得
          var superScript = superScripts.find(function(element) { return element.position == position; });
          if (superScript) {
            var kanji = words[i];
            var previous = words[i - 1];
            var containtsFontTag = previous ? fontStartTagReg.test(previous) : false;
            var hasFontTag = false;

            // ふりがな分の漢字を取得
            for (var j = 1; j < superScript.length; j++) {
              var word = words[++i];
              // fontタグ内か判定
              if (containtsFontTag) {
                // fontタグ内の場合、内部のfontタグは無視する
                if (fontStartTagReg.test(word) || fontEndTagReg.test(word)) {
                  j--;
                } else {
                  kanji += word;
                  position++;
                }
              } else {
                // fontタグ内ではない場合、内部のfontタグを漢字に含める
                if (fontStartTagReg.test(word)) {
                  j--;
                  hasFontTag = true;
                } else if (fontEndTagReg.test(word)) {
                  j--;
                  hasFontTag = false;
                } else {
                  position++;
                }
                kanji += word;
              }
            }

            // 内部のfontタグで終了タグが未処理の場合、終了タグを取得する
            var next = words[i + 1];
            if (!containtsFontTag && hasFontTag && fontEndTagReg.test(next)) {
              kanji += next;
              i++;
            }

            // ふりがな付与
            result += "<ruby>" + kanji + "<rt>" + superScript.text + "</rt>" + "</ruby>";
          } else {
            // ふりがな無し
            result += "<ruby>" + words[i] + "<rt>&nbsp;</rt></ruby>";
          }
          position++;
        }
      }

      return result;
    },
    /**
     * 表示モード取得
     *
     * @param {String} language 言語コード
     * @param {String} scriptId スクリプトID
     * @param {Boolean} withRuby ルビ付き表示モードか否か
     *
     * @return {String} 表示モード
     */
    getDisplayMode: function(language, scriptId, withRuby) {
      if (withRuby) {
        return this.getRubyDisplayMode(language);
      }
      switch (language) {
        case constants.LANGUAGE_CODE_HEIL:
          if (scriptId == constants.TEXT_SCRIPTID_VOWELED) {
            return constants.DISPLAY_MODE_VOWELED;
          } else {
            return constants.DISPLAY_MODE_UNVOWELED;
          }
        case constants.LANGUAGE_CODE_ZHCV:
          if (scriptId == constants.TEXT_SCRIPTID_PINYIN) {
            return constants.DISPLAY_MODE_PINYIN_ONLY;
          } else {
            return constants.DISPLAY_MODE_NO_PINYIN;
          }
        case constants.LANGUAGE_CODE_JAJP:
          switch (scriptId) {
            case constants.TEXT_SCRIPTID_KANJI:
              return constants.DISPLAY_MODE_KANJI;
            case constants.TEXT_SCRIPTID_KANA:
              return constants.DISPLAY_MODE_KANA;
            default:
              return constants.DISPLAY_MODE_ROMAJI;
          }
        default:
          return constants.DISPLAY_MODE_NONE;
      }
    },
    /**
     * ルビ付き表示モード取得
     *
     * @param {String} language 言語コード
     *
     * @return {String} 表示モード
     */
    getRubyDisplayMode: function(language) {
      switch (language) {
        case constants.LANGUAGE_CODE_ZHCV:
          return constants.DISPLAY_MODE_WITH_PINYIN;
        case constants.LANGUAGE_CODE_JAJP:
          return constants.DISPLAY_MODE_KANJI_WITH_KANA;
        default:
          return constants.DISPLAY_MODE_NONE;
      }
    },
    /**
     * 指定されたActに画像用テキストが存在するか否かを返す
     *
     * @param {Object} act Act要素
     *
     * @return {Boolean} true：存在する, false：存在しない
     */
    hasImageText: function(act) {
      return 0 < act.imageTexts.length;
    },
    /**
     * 指定されたActの画像用テキストを取得する
     *
     * @param {String} language 言語コード
     * @param {Object} act Act要素
     * @param {String} scriptType スクリプトタイプ
     *
     * @return {String} 画像用テキスト
     */
    getImageText: function(language, act, scriptType) {
      var result = "";

      if (this.hasImageText(act)) {
        var imageText;
        switch (language) {
          case constants.LANGUAGE_CODE_ZHCV:
            var scriptId = scriptType;
            imageText = act.imageTexts.find(function(script) { return script.scriptID == scriptId; });
            if (!imageText) {
              scriptId = constants.TEXT_SCRIPTID_PINYIN;
              imageText = act.imageTexts.find(function(script) { return script.scriptID == scriptId; });
            }
            break;
          default:
            imageText = act.imageTexts[0];
            break;
        }
        result = imageText.text;
      }

      return result;
    },
    /**
     * 拡大表示ボタン表示判定
     *
     * @param {String} language 言語コード
     * @param {String} displayMode 表示形式
     *
     * @returns {Boolean}
     */
    isShowPinchInBtn: function(language, displaymode) {
      var showPichInBtn = false;

      if (!this.isEnvironmentPc()) {
        // モバイルアプリ
        return showPichInBtn;
      }

      switch (language) {
        case constants.LANGUAGE_CODE_ZHCV:
          // 中国語
          if (displaymode == constants.DISPLAY_MODE_WITH_PINYIN) {
            // ピンイン付きの場合
            showPichInBtn = true;
          }
          break;
        case constants.LANGUAGE_CODE_JAJP:
          // 日本語
          if (displaymode == constants.DISPLAY_MODE_KANJI_WITH_KANA) {
            showPichInBtn = true;
          }
          break;
        default:
          break;
      }

      return showPichInBtn;
    },
    /**
     * ヘルプダイアログ表示テキスト取得
     * @param string modeGroup
     * @param bool sreUse 音声機能有効フラグ
     * @returns string
     */
    getHelpDialogText: function(modeGroup, sreUse) {
      var msg = "";
      switch (modeGroup) {
        case constants.MODE_GROUP_ACT_CHOICE:
          msg = "下の中から適切な選択肢をクリックします。";
          break;
        case constants.MODE_GROUP_CUE_CHOICE:
        case constants.MODE_GROUP_TILE:
        case constants.MODE_GROUP_SPEECH:
        case constants.MODE_GROUP_MILESTONE:
          msg = "上に並んでいる選択肢をクリックします。";
          break;
        default:
          break;
      }
      return msg;
    },
    /**
     * ヘルプダイアログ表示補足テキスト取得
     * @param string modeGroup
     * @param bool sreUse 音声機能有効フラグ
     * @returns string
     */
    getHelpDialogHosokuText: function(modeGroup, sreUse) {
      var msg = "";
      switch (modeGroup) {
        case constants.MODE_GROUP_ACT_CHOICE:
          msg = "フレーズに合う写真をクリックします。";
          break;
        case constants.MODE_GROUP_CUE_CHOICE:
          msg = "下のテキストまたは写真と合うメッセージをクリックします。";
          break;
        case constants.MODE_GROUP_TILE:
          msg = "正しい選択肢をクリックします。";
          break;
        case constants.MODE_GROUP_SPEECH:
          if (sreUse == "true") {
            // 音声機能ON
            msg = "聞こえたフレーズを繰り返すか、新しいフレーズを作成します。";
          } else {
            // 音声機能OFF
            msg = "正しい選択肢をクリックします。";
          }
          break;
        case constants.MODE_GROUP_MILESTONE:
          msg = "会話に合ったフレーズを話します。";
          break;
        default:
          break;
      }
      return msg;
    },
    /**
     * 文字列のHTMLタグを削除する
     *
     * @param {String} str HTMLタグ削除前の文字列
     * @return {String} HTML削除後の文字列
     */
    tagErase: function(str) {
      this.log("tagErase before: " + str);
      str = str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
      this.log("tagErase after: " + str);
      return str;
    },
    /**
     * APNAMEを取得する
     *
     * @return {String} APNAME
     */
    getApName: function() {
      if (this.isSoftbank()) {
        var packageName = window.Phone.GetPackageName();
        var index = packageName.lastIndexOf("rosetta_");
        var result = packageName.substr(index);
        return result.replace(".stg", "");
      } else {
        return "";
      }
    },
    /**
     * 古いバージョン(バージョン：10以前)のSafariか否かを返す
     *
     * @return {Boolean} true：Safariのバージョン：10以前、false：左記以外
     */
    isOldSafari: function() {
      let result = false;
      if (this.isEnvironmentPc() && platform.name == "Safari") {
        let version = platform.version;
        let major = Number(version.substring(0, version.indexOf(".")));
        result = major < constants.SAFARI_HTML5_VERSION;
      }
      return result;
    },
    /**
     * 単語一覧を取得
     */
    getDictionaryWordList: function(pathstep) {
      var res = [];
      var self = this;

      var acts = pathstep.acts;
      acts.forEach(function(actInfo) {
        var texts = actInfo.texts;
        texts.forEach(function(textInfo) {
          // htmlタグを削除
          var text = self.tagErase(textInfo.basicText);
          // 空白で分割
          var wordList = text.split(" ");
          wordList.forEach(function(word) {
            // 英字と'と-以外の文字を除去
            word = word.replace(/[^a-zA-Z'-]/g, "");
            if (word != "-") {
              if (!self.isSameValue(res, word)) {
                res.push(word);
              }
            }
          });

          // 選択肢を確認
          var confusers = textInfo.confusers;
          confusers.forEach(function(confuser) {
            confuser.forEach(function(info) {
              if (!self.isSameValue(res, info.text)) {
                res.push(info.text);
              }
            });
          });
        });
      });

      return res;
    },
    /**
     * 配列に同じ値がある場合、trueを返却する
     */
    isSameValue: function(list, value) {
      var res = true;

      if (value.length == 0) {
        return res;
      }

      res = list.some(function(data) {
        // 小文字に変換
        var lowData = data.toLowerCase();
        var lowValue = value.toLowerCase();
        return lowData === lowValue;
      });

      return res;
    },
    /**
     * ポップアップ辞書を表示する言語かを判定する
     *
     * @param {String} language 判定対象の言語
     *
     * @return {boolean} 判定結果 true: 表示対象 false: 表示対象外
     */
    isShowPopupDictionary: function(language) {
      return constants.POPUP_DICTIONARY_LANGUAGE_LIST.indexOf(language) >= 0;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/common.js